import React from 'react';
import { CloudRain, ArrowRight, Radio } from 'lucide-react';
import { liveDonations } from '../mock';

export default function TopBars() {
  // Build stable keys since the ticker duplicates each donation for a seamless loop.
  const items = [
    ...liveDonations.map((d, i) => ({ ...d, _key: `a-${i}-${d.donor}-${d.amount}` })),
    ...liveDonations.map((d, i) => ({ ...d, _key: `b-${i}-${d.donor}-${d.amount}` })),
  ];
  return (
    <>
      {/* Hivernage banner */}
      <a href="#hivernage" className="block bg-[#0e3a3a] text-[#e7f3e6] hover:bg-[#0c3232] transition-colors">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 h-12 flex items-center justify-between text-[13px]">
          <div className="flex items-center gap-2">
            <CloudRain className="w-4 h-4 text-sky-300" />
            <span className="opacity-90">Saison des pluies, saison de la solidarité.</span>
            <span className="hidden sm:inline ml-2 bg-amber-300 text-[#0e3a3a] font-semibold text-[10.5px] tracking-wide px-2 py-0.5 rounded">+40% FODINDIN</span>
          </div>
          <div className="flex items-center gap-3">
            <span className="hidden sm:inline text-[12px] bg-white/10 px-2 py-1 rounded-full">J-97</span>
            <span className="flex items-center gap-1.5 group">Découvrir <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-0.5 transition-transform" /></span>
          </div>
        </div>
      </a>

      {/* Live donations ticker */}
      <div className="bg-white border-b border-black/5 overflow-hidden">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 h-10 flex items-center gap-4">
          <div className="flex items-center gap-1.5 shrink-0 text-[11px] font-medium tracking-wider uppercase text-neutral-700">
            <span className="relative flex w-2 h-2">
              <span className="absolute inset-0 rounded-full bg-rose-500 animate-ping opacity-75"></span>
              <span className="relative inline-flex rounded-full w-2 h-2 bg-rose-500"></span>
            </span>
            En direct · 0 dons aujourd'hui
          </div>
          <div className="relative flex-1 overflow-hidden">
            <div className="marquee-track flex gap-8 whitespace-nowrap text-[12.5px] text-neutral-700">
              {items.map((d) => (
                <span key={d._key} className="inline-flex items-center gap-2 shrink-0">
                  <span className={`text-[10px] font-bold px-1.5 py-0.5 rounded ${d.type === 'Yako' ? 'bg-[#5a8268] text-white' : 'bg-[#d97757] text-white'}`}>{d.type}</span>
                  <span className="font-medium text-neutral-900">{d.donor}</span>
                  <span>a donné</span>
                  <span className="font-semibold text-neutral-900">{d.amount}</span>
                  <span>pour</span>
                  <em className="not-italic text-neutral-900">{d.cause}</em>
                  <span className="text-neutral-500">· {d.country}</span>
                </span>
              ))}
            </div>
            <div className="pointer-events-none absolute inset-y-0 left-0 w-12 bg-gradient-to-r from-white to-transparent" />
            <div className="pointer-events-none absolute inset-y-0 right-0 w-12 bg-gradient-to-l from-white to-transparent" />
          </div>
        </div>
      </div>
    </>
  );
}
